module.exports = __webpack_public_path__ + "img/20GP_HQ.03d9981a.svg";